export type OAuthGrants = 'password' | 'code';

export interface Environment {
  production: boolean;
  onlyWeb?: boolean;
  appId?: string;
  authentication?: {
    grants: Array<OAuthGrants>;
  };
  pinConfiguration?: PinConfiguration;
  biometricConfiguration?: BiometricConfiguration;
  sentry?: {
    dsn: string;
    tracesSampleRate?: number;
    replaysSessionSampleRate?: number;
    replaysOnErrorSampleRate?: number;
  };
  // eslint-disable-next-line @typescript-eslint/member-ordering
  [index: string]: unknown;
}

export type PinConfiguration = {
  storage: 'persistent' | 'session';
};
export const DefaultPinConfiguration: PinConfiguration = {
  storage: 'persistent',
};

export type BiometricConfiguration = {
  enabled: boolean;
  backgroundLockSeconds?: number | null;
};
export const DefaultBiometricConfiguration: BiometricConfiguration = {
  enabled: true,
  backgroundLockSeconds: 5,
};
